import type { DropdownData } from '@fitogest/reactive-form-builder/interfaces';
import type { FullMapModel } from 'src/app/models/form-common/full-map.model';
import type { ParcelasModel } from 'src/app/models/form-common/parcelas.model';
import { ParcelasReaReviewAdapter } from './parcelas-rea-review.adapter';

export type ParcelasReaFincaSelectionSyncContext = {
    readonly pendingFincaId: string;
    readonly fincaDropdown: DropdownData<unknown>;
    readonly hasCurrentMap: boolean;
    readonly applyModelPatch: (patch: Partial<ParcelasModel>) => void;
    readonly applyFormModelPatch: (patch: Partial<ParcelasModel>) => void;
    readonly setSelectedFinca: (selectedFinca: unknown) => void;
    readonly patchFincaControl: (fincaId: string) => void;
    readonly markFincaControlPristine: () => void;
    readonly applyMapPatch: (patch: Partial<FullMapModel>) => void;
    readonly updateReactiveForm: () => void;
};

export type ParcelasReaFincaSelectionSyncResult =
    | {
        readonly applied: false;
    }
    | {
        readonly applied: true;
        readonly fincaId: string;
        readonly selectedFinca: unknown | null;
    };

/**
 * Synchronises the visual form state after a REA review draft preselects a finca.
 */
export class ParcelasReaFincaSelectionAdapter {

    public static synchronize(context: ParcelasReaFincaSelectionSyncContext): ParcelasReaFincaSelectionSyncResult {
        const selection = ParcelasReaReviewAdapter.resolveFincaSelection({
            pendingFincaId: context.pendingFincaId,
            fincaDropdown: context.fincaDropdown,
        });

        if (selection === null) {
            return { applied: false };
        }

        context.applyModelPatch(selection.modelPatch);
        context.applyFormModelPatch(selection.modelPatch);

        if (selection.selectedFinca !== null) {
            context.setSelectedFinca(selection.selectedFinca);
        }

        context.patchFincaControl(selection.fincaId);
        context.markFincaControlPristine();

        if (context.hasCurrentMap) {
            context.applyMapPatch(selection.mapPatch);
        }

        context.updateReactiveForm();

        return {
            applied: true,
            fincaId: selection.fincaId,
            selectedFinca: selection.selectedFinca,
        };
    }
}
